//
// User store
//
// Fetches and stores all user data. Entities that can be managed by
// this user are stored in their respective submodules.
//

import { normalize } from 'normalizr';
import * as client from 'api/client';
import { user } from 'api/schema';
import { LOGOUT, invalidate, getToken } from './auth';
import {fetchSlideShows} from "./slideShows";

// ------------------------------------
// Action definitions
// ------------------------------------

export const REQUEST_ENTITIES = 'USER/REQUEST';
export const RECEIVE_ENTITIES = 'USER/RECEIVE';
export const ERROR = 'USER/ERROR';

// ------------------------------------
// Action creators
// ------------------------------------

export const requestEntities = () => ({
  type: REQUEST_ENTITIES
});

export const receiveEntities = entities => ({
  type: RECEIVE_ENTITIES,
  entities
});

export const fetchUserData = () => (dispatch, getState) => {
  dispatch(requestEntities());

  const state = getState();
  const token = getToken(state);

  return client.get('/api/users/me', token)
    .then(json => {
      const { entities } = normalize(json, user);
      dispatch(receiveEntities(entities));

      // if museum teacher, get additional data
      // console.log(json, entities);
      if (json && json.museum_teacher) {
        dispatch(fetchSlideShows());
      }
    })
    .catch(() => {
      // Stored token is probably no longer valid.
      dispatch(fail());
      dispatch(invalidate());
    });
};

export const fail = () => ({ type: ERROR });

// ------------------------------------
// Initial state
// ------------------------------------

const initialState = {
  fetching: false,
  id: null,
  name: null,
  email: null,
  schools: [],
  classes: [],
  museum_teacher: false,
};

// ------------------------------------
// Reducer
// ------------------------------------

export default (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_ENTITIES:
      return {
        ...state,
        fetching: true
      };

    case RECEIVE_ENTITIES:
      const user = Object.values(action.entities.users)[0];
      return {
        ...user,
        fetching: false
      };

    case ERROR:
      return {
        ...state,
        fetching: false
      };

    case LOGOUT:
      return initialState;

    default:
      return state
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js